import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { environment } from '@env/environment';
import { DomSanitizer, SafeResourceUrl, } from '@angular/platform-browser';

@Component({
  selector: 'learnspace-welcome-dialog',
  templateUrl: './learnspace-welcome-dialog.component.html',
  styleUrls: ['./learnspace-welcome-dialog.component.scss']
})
export class LearnspaceWelcomeDialogComponent implements OnInit {
  url: SafeResourceUrl;
  constructor(
    public _dialogRef: MatDialogRef<LearnspaceWelcomeDialogComponent>,
    private sanitizer: DomSanitizer,
    // @Inject(MAT_DIALOG_DATA) public _data
  ) { }

  ngOnInit(): void { 
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.welcomeMessageUrl);
  }
}
